function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}


docReady(doIt);
function doIt() {
  // window.onWizzyScriptLoaded = function () {



    if(document.documentElement.clientWidth < 768) {
        let isAutocompleteMutationConfigured = false;
    
        const setMutationToAutocomplete = (id, options = {}) => {
          if (isAutocompleteMutationConfigured) return;
        
          let mutationHandler = (target) => {
            console.log(target)
            let targetEle = target;
            let isVisible;
    
            if(targetEle.hasChildNodes()) {
              var x = targetEle.querySelector(".wizzy-autocomplete-wrapper");
              if(x != null) {
                isVisible = window.getComputedStyle(targetEle.querySelector(".wizzy-autocomplete-wrapper")).display === "flex";
              }else {
                return;
              }
            }else {
              if(targetEle.classList.contains("wizzy-autocomplete-wrapper")) {
                isVisible = window.getComputedStyle(targetEle).display === "flex";
                console.log("Came till here");
              }else {
                return;
              }
            }
        
            if (isVisible) {
              
              var x = document.querySelector('.wizzy-autocomplete-wrapper');
              if(getComputedStyle(x).display === 'none') {
                document.body.classList.remove("wizzy-autocomplete-is-visible");
                document.body.classList.add("wizzy-autocomplete-is-not-visible");
              }
              var currentTop = parseInt(x.style.top) || 0;
              var newTop = currentTop + 15;
              x.style.top = newTop + 'px';
              document.body.classList.add("wizzy-autocomplete-is-visible");
              document.body.classList.remove("wizzy-autocomplete-is-not-visible");
            } else {
              document.body.classList.remove("wizzy-autocomplete-is-visible");
              document.body.classList.add("wizzy-autocomplete-is-not-visible");
            }
          };
        
          let mutationStaticObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutationRecord) {
              switch (mutationRecord.type) {
                case "childList":
                  setTimeout(function() {
                    mutationHandler(mutationRecord.target);
                  }, 200);
                  break;
                case "subtree":
                  break;
                default:
                  // mutationHandler(mutationRecord.target);
              }
            });
          });
        
          mutationStaticObserver.observe(document.getElementById(id), options);
          isAutocompleteMutationConfigured = true;
        };
        
        let autocompleteId = ".wizzy-body-end-wrapper";
        document.querySelector(autocompleteId).setAttribute("id", "wizzy-body-end-wrapper");
        setMutationToAutocomplete("wizzy-body-end-wrapper", {
          subtree: true,
          childList: true,
          attributes: true,
        });
    
    
        document.querySelector("body").addEventListener("click", function (e) {
          let bodyEle = document.querySelector("body");
          let autocompleteWrapper = document.querySelector('.wizzy-autocomplete-wrapper');
          if(autocompleteWrapper !== null && typeof autocompleteWrapper !== 'undefined') {
            if(getComputedStyle(autocompleteWrapper).display == 'none' && bodyEle.classList.contains("wizzy-autocomplete-is-visible")) {
              document.body.classList.remove("wizzy-autocomplete-is-visible");
              document.body.classList.add("wizzy-autocomplete-is-not-visible");
            }
          }
        }); 
    }
  





    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
            if(mutationRecord.target.getAttribute('aria-hidden') == 'false') {
              setTimeout(function() {
                document.getElementById('wizzy-search').focus();
              }, 200);
            }else if(mutationRecord.target.getAttribute('aria-hidden') == 'true') {
              
            }
        });    
    });
    
    var target = document.getElementById('Search');
    observer.observe(target, { attributes : true, attributeFilter : ['aria-hidden'] });
  



  
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {

        data["search"]["configs"]["pagination"]["infiniteScrollOffset"] = { desktop: 7000, mobile: 7000 };
        
        data.common.lazyDOMConfig.contentDOMIdentifiers[0] = 'main';

        if(data.common.isOnCategoryPage === true) {
          data.common.lazyDOMConfig.contentDOMIdentifiers[0] = ".CollectionMain";
        }
        
        data.common.lazyDOMConfig.searchInputIdentifiers[0].dom = "#section-header input";
        data.common.lazyDOMConfig.searchInputIdentifiers[0].type = "search";
        data.common.lazyDOMConfig.identifiersToClickOnSearch[0] = '.Search__Close';
        return data;
    });

  
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(data) {
      let n = data.length;

      for(let i = 0; i < n; i++) {

        if(data[i].price != null) {
          data[i].price = data[i].price.replaceAll(".00", '');
        }

        if(data[i].sellingPrice != null) {
          data[i].sellingPrice = data[i].sellingPrice.replaceAll(".00", '');
        }
        
        let m = data[i].attributes.length;
        for(let j = 0; j < m; j++) {
          if(data[i].attributes[j].id === "product_value_tags_bestseller") {
            data[i].isBestSeller = true;
          }else if(data[i].attributes[j].id === "product_value_tags_new_arrivals") {
            data[i].isNewArrival = true;
          }else if(data[i].attributes[j].id === "product_badge_judgeme") {
            htmlCode = data[i].attributes[j].values[0].value[0];
            const tempElement = document.createElement('div');
            tempElement.innerHTML = htmlCode;
            
            const badgeElement = tempElement.querySelector('.jdgm-prev-badge[data-average-rating]');
            if(badgeElement) {
              const averageRating = badgeElement.getAttribute('data-average-rating');
              const totalRating = badgeElement.getAttribute('data-number-of-reviews');
              if(averageRating && totalRating) {
                data[i]["avgRatings"] = parseFloat(averageRating).toFixed(1);
                data[i]["totalReviews"] = totalRating;
              }
            }
          }
        }
      }
      return data;
    });


    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
      if(document.documentElement.clientWidth < 768) {
        var x = document.querySelector("body");
        if (x.classList.contains("wizzy-autocomplete-is-visible")) {
          x.classList.remove("wizzy-autocomplete-is-visible");
          x.classList.add("wizzy-autocomplete-is-not-visible");
        }
      }
      return data;
    });


  
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(data) {
      var facets = data.response.payload.facets;
      facets.forEach((facet) => {
          if (facet.key === "colors") {
              const facetItem = facet.data;
              facetItem.forEach((item) => {
                  item.isSwatch = true;
                  item.isVisualSwatch = true;
                  item.swatchValue = false;
                  item.data = {
                      value: item.key,
                      swatch: {
                          type: 'visual',
                          value: false
                      }
                  }
              })
          }
      })
      return data;
    })


    window.addEventListener("scroll", function(event) {
      if((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) > 100) {
        document.querySelector(".wizzy-scroll-to-top-wrapper").style.display = "flex";
        document.querySelector(".wizzy-scroll-to-top-wrapper").style.opacity = "1";
      }else {
        document.querySelector(".wizzy-scroll-to-top-wrapper").style.display = "none";
        document.querySelector(".wizzy-scroll-to-top-wrapper").style.opacity = "0";
      }
    });


    $('body').on('click','.wizzy-facet-list-item, .wizzy-selected-facet-list-item', function(e) {
      var x = document.querySelector(".wizzy-main-content");
      if(x !== null && typeof x !== 'undefined') {
        setTimeout(function() {
          x.scrollIntoView();
        }, 500)
      }
    })


    changeTemplate('wizzy-search-results-product');
    changeTemplate('wizzy-search-results');
  // }
}


const changeTemplate = (div) => {
  let oldDiv = document.getElementById(div);
  let newDiv = document.getElementById(div + '-new').text;
  oldDiv.text = newDiv;
}